import { useQueryClient } from "@tanstack/react-query";

interface RefreshOptions {
  assetPositionId?: string;
  assetId?: string;
}

export default function useRefreshAssetRegister(options?: RefreshOptions) {
  const queryClient = useQueryClient();

  return async function refreshLists(overrideOptions?: RefreshOptions) {
    const { assetPositionId, assetId } = {
      ...options,
      ...overrideOptions,
    };
    await Promise.all([
      queryClient.invalidateQueries({
        queryKey: [{ url: "/asset" }],
        refetchType: "all",
      }),
      queryClient.invalidateQueries({
        queryKey: [
          { url: "/asset_position/link" },
          {
            asset_position_id: assetPositionId,
          },
        ],
        refetchType: "all",
      }),
      queryClient.invalidateQueries({
        queryKey: [
          { url: "/asset_register" },
          { asset_position_id: assetPositionId },
        ],
        refetchType: "all",
      }),
      queryClient.invalidateQueries({
        queryKey: [{ url: "/asset" }, { asset_id: assetId }],
        refetchType: "all",
      }),
      queryClient.invalidateQueries({
        queryKey: [{ url: "/asset_position/link" }, { asset_id: assetId }],
        refetchType: "all",
      }),
    ]);
  };
}
